/* Copyright(c) 2024 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
/*
@author:Priyanka Patil
@Description: 5465-DC Dashboard Page created
date: 15-10-2024
*/

import React from "react";
import Select from "react-select";//Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
import { connect } from "react-redux";
import Navigation from "../layouts/navPage";
import PropTypes from "prop-types";
import Footer from "../layouts/footer";
import "./publisherEmailConfig.css";
import "antd/dist/antd.css";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import { css } from "emotion";
import { Table, Button } from "antd";
import "./dashboardDC.css";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";
import Swal from "sweetalert2";

const tableCSS = css({
  backgroundColor: "white",
  borderStyle: "bold",
  "& thead  > tr": {
    backgroundImage: "linear-gradient(to right,#28166f,#007cc3) !important",
    color: "white",
    fontSize: "12px",
    textAlign: "center",
    fontWeight: "500",
  },
  "& thead > tr >th": {
    textAlign: "center",
    color: "white",
  },
});

class qualityDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignDetails: [],
      tableState: { size: "small" }, //Array for table properties
      tableSearchText: "",
      campID: "",
      advCampID: "",
      loading1: true,
      parentCampID: "",
      reallocationID: "",
      loader_progress: "",
      campList: [],
      campDetails: [],
      leadDetails: [],
      getLeadCounts: "",
      leadDetailsCount: "",
      diqaList: [],
      selectedDiqaList: [],
      selectedDiqa: [],
      diqaAssignedList: [],
      diqa: [],
      pageSize: 25,
      selectedDiqaForAssign: {}, //Anshul-5857: added selected diqa for assign
      selectedCampForAssignAll: null, // Kiran 5847 - selected campaign for assign all
    };
    this.displayCampaignSpecification =
      this.displayCampaignSpecification.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleAssignClick = this.handleAssignClick.bind(this); //Chaitanya-5430-Added function
  }

  componentWillMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push("/userLogin");
      return;
    }
  
    const { user } = this.props.auth;
    this.setState({ role: user.role, loader_progress: "loader_campaign_list" });
  
    let self = this;
  
    //Priyanka-5474-calling route to update lead count
    fetch("/diQARole/updateLeadCount", 
      { method: "POST", 
        headers: { "Content-Type": "application/json" }
      }).then((res) =>
      res.json());

    //Chaitanya-5474-Fetch leadReviewDI and leadReviewPV in parallel
    //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
    Promise.all([
      fetch("/diQARole/leadReviewDI", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ role: user.role }) }).then((res) =>
        res.json()
      ),
      //Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel
      //commented PV review as only show the DIQA Review campaigns
      // fetch("/diQARole/leadReviewPV", { method: "POST", headers: { "Content-Type": "application/json" } }).then((res) =>
      //   res.json()
      // ),
    ])
      .then(([campList]) => {
        const combinedList = [...campList];
        //console.log("campList ==> ", campList);
        //console.log("campListPV ==> ", campListPV);
  
        // Merge by campID
        const campMap = new Map();
        combinedList.forEach((camp) => {
          if (campMap.has(camp.campID)) {
            const existingCamp = campMap.get(camp.campID);
            existingCamp.totalLeadCount =
              Number(existingCamp.totalLeadCount) + Number(camp.totalLeadCount || 0);
          } else {
            campMap.set(camp.campID, { ...camp });
          }
        });
  
        const mergedData = Array.from(campMap.values());
        const data = { campList: mergedData };
        
        //Chaitanya-5474-Fetch remaining details in parallel
        return Promise.all([
          fetch("/diQARole/getPubDetails", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }).then((res) => res.json()),
          fetch("/diQARole/getDIQADetails", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }).then((res) => res.json()),
          fetch("/diQARole/getAssignedDiqa", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }).then((res) => res.json()),
         // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          fetch("/users/getUserListDIQA", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }).then((res) => res.json()),
        ]).then(([pubDetails, diqaDetails, assignedDiqa, userList]) => {
          // Process the fetched data
          const assignedDiqaList = {};
          assignedDiqa.forEach((assignment) => {
            assignedDiqaList[assignment.campID] = assignment.assignedTo;
          });
          // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          const combined = [...(diqaDetails || []), ...(userList || [])];
          const mapById = new Map();
          combined.forEach((u) => {
            if (!mapById.has(u.userID)) mapById.set(u.userID, u);
          });
          const mergedDiqaList = Array.from(mapById.values());
          this.setState({
            campList: pubDetails,
            diqaList: mergedDiqaList,//Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
            selectedDiqaList: assignedDiqaList,
            loader_progress: "",
          });
        });
      })
      .catch((err) => {
        console.error("Error loading data:", err);
        self.setState({ loading1: false, loader2: "" });
      });
  }
  
  displayCampaignSpecification(e) {
    e.preventDefault();
    var campID = e.target.getAttribute("campID");
    sessionStorage.setItem("campID", campID);
    window.open("/campaignSpecificationQADashboard");
  }

  handleChangePageSize(e) {
    var pageSize = e.target.value;
    this.setState({ pageSize: pageSize });
  }

  handleChangeSearch(e) {
    e.preventDefault();
    let currentList = [];
    // Variable to hold the filtered list before putting into state
    let newList = [];
    let filterData = e.target.value;
    // If the search bar isn't empty
    if (e.target.value === "") {
      //alert("if")
      newList = this.state.campList;
    } else {
      //alert("else"+JSON.stringify(this.state.campList))
      // Assign the original list to currentList
      currentList = this.state.campList;
      //alert("currentList-->"+JSON.stringify(currentList))

      newList = currentList.filter((item) => {
        // change current item to lowercase
        const lc = item;
        // change search term to lowercase
        const filter = e.target.value.toLowerCase();
        //alert("filter-->"+filter)
        // check to see if the current list item includes the search term
        // If it does, it will be added to newList. Using lowercase eliminates
        // issues with capitalization in search terms and search content
        var data = Object.values(lc);
        var dataFinal = data.toString();
        dataFinal = dataFinal.replace(",", " ");
        var dataToLower = dataFinal.toLowerCase();
        //alert("dataToLower-->"+dataToLower)
        return dataToLower.includes(filter);
      });
      //alert("newList-->"+JSON.stringify(newList))
    }
    // Set the filtered state based on what our rules added to newList
    this.setState({
      campListSearch: [...newList],
      tableSearchText: filterData,
    });
  }

  //Chaitanya-5430-handleAssignClick function
  handleAssignClick = (record) => {
    const hiddenInput = document.getElementById(`select-${record.campID}`);
    if (!hiddenInput || !hiddenInput.value) {
      Swal.fire({
        icon: "warning",
        type: "warning",
        title: "Please select LNQA",
        text: "",
        allowOutsideClick: false,
      });
      return;
    }

    const selectedValue = hiddenInput.value;
    
    // Retrieve selected DIQA user details based on userID Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
    const selectedDiqa = this.state.diqaList.find((diqa) => String(diqa.userID) === String(selectedValue));

    //Chaitanya-5425-Updated swal fire message "Please Select DIQA"
    // Ensure a DIQA is selected before proceeding
    if (!selectedDiqa) {
      //Chaitanya-5466-added allowOutsideClick: false
      Swal.fire({
        icon: "warning",
        type: "warning",
        title: "Please select LNQA",
        text: "",
        allowOutsideClick: false,
      });
      return;
    }

    // Data to send to backend
    const data = {
      userName: selectedDiqa.userName,
      //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
      userID: selectedDiqa.userID, // Assuming userID is part of diqaList object
      campID: record.campID, // Replace with the appropriate field for camp ID
      allocatedLead: record.totalLeadCount || 0, // preserve readable name for backend/display
      assignedTo: `${selectedDiqa.firstName} ${selectedDiqa.lastName}`, // Include the assigned DIQA name
      startDate: record.startDate, //Chaitanya-5466-passing startDate
      endDate: record.endDate,
    };

    //alert("data ==>" + JSON.stringify(data));

    fetch("/diQARole/diqa_allocation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to allocate LNQA");
        }
      })
      .then((result) => {
        //Anshul-5857:Use the DIQA's full name for display (avoid showing userID until reload)
        const assignedToName = `${selectedDiqa.firstName} ${selectedDiqa.lastName}`;

        // Anshul-5857: Update the state with the assigned DIQA name and clear the per-row selection
        this.setState((prevState) => ({
          selectedDiqaList: {
            ...prevState.selectedDiqaList,
            [record.campID]: assignedToName,
          },
          selectedDiqaForAssign: {
            ...prevState.selectedDiqaForAssign,
            // [record.campID]: selectedValue,
            [record.campID]: "",
          },
        }));

        // Show a success alert with the assigned DIQA's name
        //Chaitnya-5474-Showing Campaign ID on swal fire
        Swal.fire({
          icon: "success",
          type: "success",
          title: `Campaign ${record.campID} Assigned Successfully!`,
          // text: `Assigned to User: ${selectedDiqa.firstName} ${selectedDiqa.lastName}`,//Kiran Dhainje 5875 Ref(5847)-DC/DIQA-Showing Assigned to User ID & Rejection Reason box disabled
          text: `Assigned to User: ${assignedToName}`,//Anshul-5857: showing diqa's full name on popup
          confirmButtonText: "OK",
          allowOutsideClick: false,
          //Chaitanya-5425-After assigning campaign, refresh page
          preConfirm: () => {
            window.location.reload();
          },
        });
      })
      .catch((error) => {
        console.error("Error assigning LNQA:", error);
        Swal.fire(
          "Error",
          "There was an error assigning the LNQA. Please try again.",
          "error"
        );
      });
  };
  //Chaitanya-5474-Removing user
  removeAssignedDiqa = (campID, name) => {
    // Show confirmation popup
    Swal.fire({
      type: "warning",
      title: `Are you sure you want to remove ${name} from Campaign ${campID}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    }).then((result) => {
      // Proceed only if the user confirmed
      if (result.value === true) {
        // Find the userID for the DIQA user to be removed
        const selectedDiqa = this.state.diqaList.find(
          (user) => `${user.firstName} ${user.lastName}` === name
        );

        if (!selectedDiqa) {
          Swal.fire({
            icon: "error",
            title: "User not found",
            text: `The selected user (${name}) does not exist.`,
            allowOutsideClick: false,
          });
          return;
        }
        const { userID } = selectedDiqa;

        //Kiran Dhainje 5865 Ref(5847)-DT Dashboard-Remove Assignee functionality not working
        const assignedTo = `${selectedDiqa.firstName} ${selectedDiqa.lastName}`;
        //console.log("removeAssignedDiqa: extracted userID =", userID, "campID =", campID, "assignedTo =", assignedTo, "from selectedDiqa:", selectedDiqa);

        // Send assignedTo as well so backend can fallback to name-based removal when userID doesn't match
        //Kiran Dhainje 5865 Ref(5847)-DT Dashboard-Remove Assign functionality not working
        const payload = { campID, userID, assignedTo };
        //console.log("removeAssignedDiqa payload:", payload);

        fetch("/diQARole/updateUserStatus", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        })
        //Kiran Dhainje 5865 Ref(5847)-DT Dashboard-Remove Assign functionality not working
          .then((res) => res.json())
          .then((result) => {
              // Server will return { success: true } or { success: false, error: '...' }
              if (result && result.success === true) {
                Swal.fire({
                  icon: "success",
                  type: "success",
                  title: `${name} Removed Successfully`,
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                  preConfirm: () => {
                    window.location.reload();
                  },
                });
              } else {
                const message = (result && result.error) || (result && result.message) || "Failed to remove user";
                //console.error("removeAssignedDiqa failed:", result);
                Swal.fire({
                  icon: "error",
                  title: "Failed to Remove User",
                  text: message,
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                });
              }
            })
            .catch(function (err) {
              //console.error("Error calling updateUserStatus:", err);
              Swal.fire({
                icon: "error",
                title: "Failed to Remove User",
                text: "An unexpected error occurred. Please check the console and try again.",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            });
      }
    });
  };

  // Anshul-5857: storing selected diqa count
  getSelectedCount() {
    const map = this.state.selectedDiqaForAssign || {};
    return Object.values(map).filter((v) => v && String(v).trim() !== "").length;
  }

  handleRowSelect = (campID, selected) => {
    const val = selected ? selected.value : "";
    const hidden = document.getElementById(`select-${campID}`);
    if (hidden) hidden.value = val;
    this.setState((prev) => ({
      selectedDiqaForAssign: {
        ...prev.selectedDiqaForAssign,
        [campID]: val,
      },
    }));
  };

  isAssignAllEnabled() {
    return this.getSelectedCount() >= 2;
  }

  handleAssignAllClick = () => {
    const selectedMap = this.state.selectedDiqaForAssign || {};
    const selectedEntries = Object.keys(selectedMap).filter((k) => selectedMap[k]);
    if (selectedEntries.length === 0) {
      Swal.fire({ icon: "warning", title: "No LNQA selected", text: "Select LNQA for campaigns before assigning.", allowOutsideClick: false });
      return;
    }

    const requests = selectedEntries.map((campID) => {
      const userID = selectedMap[campID];
      const diqaUser = (this.state.diqaList || []).find((d) => String(d.userID) === String(userID));
      const campRecord = (this.state.campList || []).find((c) => String(c.campID) === String(campID)) || {};
      if (!diqaUser) {
        return Promise.reject(new Error(`LNQA user ${userID} not found`));
      }
      const data = {
        userName: diqaUser.userName,
        userID: diqaUser.userID,
        campID: campID,
        allocatedLead: campRecord.totalLeadCount || 0,
        assignedTo: `${diqaUser.firstName} ${diqaUser.lastName}`,
        startDate: campRecord.startDate,
        endDate: campRecord.endDate,
      };
      return fetch("/diQARole/diqa_allocation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }).then((res) => {
        if (!res.ok) throw new Error(`Failed to assign campaign ${campID}`);
        return res.json().then(() => ({ campID, assignedTo: data.assignedTo, userID: data.userID }));
      });
    });

    Promise.allSettled(requests).then((results) => {
      const failed = results.filter((r) => r.status === "rejected");
      const success = results.filter((r) => r.status === "fulfilled");
      if (failed.length > 0) {
        console.error("Some assignments failed:", failed);
        Swal.fire({ icon: "error", title: "Some assignments failed", text: "Check console for details.", allowOutsideClick: false });
        return;
      }

      this.setState((prev) => {
        const updated = { ...(prev.selectedDiqaList || {}) };
        success.forEach((r) => {
          const payload = r.value;
          updated[payload.campID] = payload.assignedTo;
        });
        return {
          selectedDiqaList: updated,
          selectedDiqaForAssign: {},
        };
      }, () => {
        Swal.fire({ type: "success", title: "Campaigns assigned to users successfully", allowOutsideClick: false }).then(() => window.location.reload());
      });
    }).finally(() => setTimeout(this.relocateAssignAllButton, 50));
  };

  relocateAssignAllButton = () => {
    try {
      const btn = document.querySelector('.btn.add-button.assign-all');
      const pageContainer = document.querySelector('.ant-table-pagination');
      if (!btn) return;

      if (pageContainer) {
        const paginationControls = pageContainer.querySelector('.ant-pagination');
        if (!pageContainer.contains(btn) || btn.nextSibling !== paginationControls) {
          pageContainer.insertBefore(btn, paginationControls || null);
        }
        btn.style.margin = '';
        btn.style.display = 'inline-block';
        btn.style.verticalAlign = 'middle';
      } else {
        btn.style.margin = '';
      }
    } catch (e) {
    }
  };

  componentDidMount() {
    this.relocateAssignAllButton();
    window.addEventListener('resize', this.relocateAssignAllButton);
  }

  componentDidUpdate() {
    this.relocateAssignAllButton();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.relocateAssignAllButton);
  }

  render() {
    const asterisk = {
      color: "red",
    };
    const { user } = this.props.auth;

    //5421-Chaitanya-to show columns data
    const columns = [
      {
        title: "Campaign ID",
        dataIndex: "campID",
        key: "campID",
        width: "6%",
        align: "center",
        sorter: (a, b) => a.campID - b.campID,
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "12px" }}>
              {record.campID ? record.campID : text}
            </span>
          </div>
        ),
      },
      {
        title: "Agency Camp ID",
        dataIndex: "agencycampID",
        key: "agencycampID",
        width: "6%",
        align: "center",
        sorter: (a, b) => a.agencycampID - b.agencycampID,
        render: (text, record) => (
          <div style={{ width: "75px" }}>
            <span style={{ fontSize: "12px" }}>
              {record.clientCampID ? record.clientCampID : text}
            </span>
            <br />
          </div>
        ),
      },
      //Chaitanya-5430-Added Client Name Column
      {
        title: "Client Name",
        dataIndex: "clientName",
        key: "clientName",
        width: "11%",
        align: "center",
        sorter: (a, b) => {
          const asc = "asc";
          if (a.clientName.toUpperCase() < b.clientName.toUpperCase()) {
            return asc ? -1 : 1;
          } else if (a.clientName.toUpperCase() > b.clientName.toUpperCase()) {
            return asc ? 1 : -1;
          } else {
            return 0;
          }
        },
        render: (text, record) => (
          // Anshul-5857:align text to center
          <div class="dot1" style={{ width: "100%", textAlign: "center" }} title={record.clientName}>
            {/* Chaitanya-5425-Displayed full name in tooltip for Client Name. */}
            <span style={{ fontSize: "12px" }}>
              {record.clientName ? record.clientName : text}
            </span>
          </div>
        ),
      },
      {
        title: "Campaign Name",
        dataIndex: "campaignName",
        key: "campaignName",
        width: "17%",
        align: "center",
        sorter: (a, b) => {
          const asc = "asc";
          if (a.campaignName.toUpperCase() < b.campaignName.toUpperCase()) {
            return asc ? -1 : 1;
          } else if (
            a.campaignName.toUpperCase() > b.campaignName.toUpperCase()
          ) {
            return asc ? 1 : -1;
          } else {
            return 0;
          }
        },
        render: (text, record) => (
          <div
            class="dot1"
            // Anshul-5857:align text to center
            style={{ width: "100%",textAlign: "center" }}
            title={record.campaignName}
          >
            {/* Chaitanya-5425-Displayed full name in tooltip for Campaign Name. */}
            <span>
              {record.campaignName ? (
                <a
                  href="#/" //karan-task-3895-link issue //Rutuja 2978 chnaged # to #/
                  onClick={this.displayCampaignSpecification}
                  campID={record.campID}
                  campaignName={record.campaignName}
                  parentCampID={record.parentCampID}
                  reallocationID={record.reallocationID}
                  style={{ fontSize: "12px", width: "100px" }}
                >
                  {record.campaignName}
                </a>
              ) : (
                <span style={{ fontSize: "12px", width: "100px" }}>
                  <a
                    href="#/"
                    onClick={this.displayCampaignSetup}
                    advCampID={record.advCampID}
                    agencyAllocationID={record.agencyAllocationID}
                    advCampaignName={record.advCampaignName}
                  >
                    {record.advCampaignName}
                  </a>
                </span>
              )}
            </span>
            <br />
          </div>
        ),
      },
      {
        title: "Uploaded By",
        dataIndex: "uploadedBy",
        key: "uploadedBy",
        width: "11%",
        fontSize: "12px",
        align: "center",
        sorter: (a, b) => {
          const asc = "asc";
          if (a.uploadedBy.toUpperCase() < b.uploadedBy.toUpperCase()) {
            return asc ? -1 : 1;
          } else if (a.uploadedBy.toUpperCase() > b.uploadedBy.toUpperCase()) {
            return asc ? 1 : -1;
          } else {
            return 0;
          }
        },
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "12px" }}>
              {record.uploadedBy ? record.uploadedBy : text}
            </span>
          </div>
        ),
      },
      {
        title: "Reviewed By",
        dataIndex: "reviewedBy",
        key: "reviewedBy",
        width: "11%",
        fontSize: "12px",
        align: "center",
        sorter: (a, b) => {
          const asc = "asc";
          if (a.reviewedBy.toUpperCase() < b.reviewedBy.toUpperCase()) {
            return asc ? -1 : 1;
          } else if (a.reviewedBy.toUpperCase() > b.reviewedBy.toUpperCase()) {
            return asc ? 1 : -1;
          } else {
            return 0;
          }
        },
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "12px" }}>
              {record.reviewedBy ? record.reviewedBy : text}
            </span>
          </div>
        ),
      },
      {
        title: "Lead Count",
        align: "center",
        width: "5%",

        align: "center",
        sorter: (a, b) => a.totalLeadCount - b.totalLeadCount,
        render: (text, record) => (
          <div style={{ width: "55px" }}>
            <span style={{ fontSize: "12px" }}>
              {record.totalLeadCount ? record.totalLeadCount : text}
            </span>
            <br />
          </div>
        ),
      },
      {
        title: "Assigned To",
        width: "11%",
        align: "center",
        sorter: (a, b) => a.campID - b.campID,
        render: (text, record) => {
          //Priyanka-5474-Displaying cross sign to remove existing user
          // Find the corresponding entry in selectedDiqaList based on campID
          const assignedTo = this.state.selectedDiqaList[record.campID];
          //alert("assignedTo ==>"+JSON.stringify(assignedTo))
          // If assignedTo exists, split it into an array and render each name
          //Chaitanya-5474-Added cross mark , to remove existing diqa name
          return (
            <div>
              {assignedTo ? (
                assignedTo.split(",").map((name, index) => (
                  <div key={index} style={{ fontSize: "12px" }}>
                    {name}
                    &nbsp;&nbsp;
                    <a
                      title="Remove Assignee"
                      href="#"
                      className="removeFilePOC"
                      onClick={(e) => {
                        e.preventDefault();
                        this.removeAssignedDiqa(record.campID, name);
                      }}
                    >
                      <i
                        className="fa fa-times"
                        style={{ color: "#0278C0", cursor: "pointer" }}
                      />
                    </a>
                  </div>
                ))
              ) : (
                <span style={{ fontSize: "12px" }}>Not Assigned</span> // Fallback if no assignedTo data
              )}
            </div>
          );
        },
      },
      {
        title: "Assign",
        dataIndex: "",
        key: "",
        width: "20%",
        sorter: (a, b) => a.campID - b.campID,
        render: (text, record) => {
          //Priyanka-5474-Get the list of already assigned DIQA names for the current campaign
          const assignedUsers = this.state.selectedDiqaList[record.campID]
            ? this.state.selectedDiqaList[record.campID].split(",")
            : [];
      
          //Priyanka-5474-Filter diqaList to exclude already assigned users
          // Also restrict to DIQAs whose orgID matches the current DC user's orgID
          // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          //Kiran Dhainje 5862 Ref(5847)-DC/DT-Assign dropdown showing DC/DT Name
          //Chaitanya-6031-Ref(6007)-LC-LNQA Member Name Not Displayed in “Select LNQA” Dropdown
          const availableUsers = this.state.diqaList.filter(
            (diqa) =>
              !assignedUsers.includes(`${diqa.firstName} ${diqa.lastName}`) &&
              // Only include DIQA role users
              diqa.role && String(diqa.role).toUpperCase() === "LNQA" &&
              diqa.orgID === user.id &&
              // Only include active users (status not 'N')
              diqa.status !== 'N'
          );
          //console.log("availableUsers", availableUsers);
      
          //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
                flexWrap: "nowrap",
              }}
            >
              <div style={{ flex: "0 0 180px", maxWidth: "180px" }}>
                {/*//Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel */}
                {/*//Kiran Dhainje 5860 Ref(5847)-DC/DT-Assign button alignment issue */}
                <Select 
                  id={`select-${record.campID}-select`}
                  isClearable
                  options={availableUsers.map((diqa) => ({
                    value: diqa.userID,
                    label: `${diqa.firstName} ${diqa.lastName}`,
                  }))}
                  placeholder="-- Select LNQA --"
                  isSearchable={true}
                  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                  menuPosition="fixed"
                  onChange={(selected) => {
                    //  const hidden = document.getElementById(`select-${record.campID}`);
                    // if (hidden) {
                    //   hidden.value = selected ? selected.value : "";
                    // }
                    this.handleRowSelect(record.campID, selected);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "34px",
                      height: "auto",
                      fontSize: "12px",
                      width: "100%",
                      boxSizing: "border-box",
                    }),
                    menu: (base) => ({ ...base, fontSize: "12px", zIndex: 9999 }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />

                <input type="hidden" id={`select-${record.campID}`} />
              </div>

              {/* <div style={{ flex: "0 0 auto" }}>
                <Button
                  onClick={() => this.handleAssignClick(record)}
                  style={{ height: "34px", whiteSpace: "nowrap" }}
                >
                  Assign
                </Button>
              </div> */}
              {/* Anshul-5857: replaced button with icon */}
              <div style={{ flex: "0 0 auto",}}>
                <div
                  className={
                    "btn add-button assign-icon " + (
                      this.state.selectedDiqaForAssign &&
                      this.state.selectedDiqaForAssign[record.campID] &&
                      this.getSelectedCount() === 1
                        ? ""
                        : "disabled"
                    )
                  }
                  onClick={() => {
                    const enabled = this.state.selectedDiqaForAssign &&
                      this.state.selectedDiqaForAssign[record.campID] &&
                      this.getSelectedCount() === 1;
                    if (!enabled) return;
                    this.handleAssignClick(record);
                  }}
                  title={
                    this.getSelectedCount() > 1
                      ? "Disabled while multiple campaigns are selected"
                      : "Assign"
                  }
                />
              </div>
            </div>
          );
        },
      }
    ];

    function onChange(pagination, filters, sorter) {
      console.log("params", pagination, filters, sorter);
    }

    return (
      <div>
        <Navigation />
        <div
          className="container-fluid"
          id="Container-PUB"
          // style={{ paddingTop: "85px", paddingBottom: "60px" }}
          style={{ marginTop: "80px", paddingBottom: "60px" }}
        >
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-9">
              <span>
                <p
                  className="campaignOverview"
                  style={{
                    fontFamily: "roboto",
                    color: "black",
                    fontSize: "26px",
                    fontWeight: "500",
                    marginBottom: "20px",
                    marginTop: "25px",
                  }}
                >
                  {/* RUtuja LNQA task */}
                  LNQA Allocation &nbsp;&nbsp;
                  {/*Chaitanya-5430-Changed title from "Campaigns for Lead Review" to "DIQA Allocation" */}
                </p>
              </span>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
              <input
                type="text"
                className="inputstyle4"
                name="search"
                placeholder="Search Campaign"
                style={{
                  backgroundImage: "url(searchIcon.png)",
                  backgroundPosition: "15px 8px",
                  backgroundSize: "15px 15px",
                  backgroundRepeat: "no-repeat",
                  width: "280px",
                  height: "28px",
                  fontSize: "12px",
                  border: "1px solid #CCCCCC",
                  padding: "15px 20px 15px 36px",
                  backgroundColor: "#FFFFFF",
                  fontFamily: "sans-serif",
                  borderRadius: "2px",
                  marginTop: "35px",
                  borderRadius:"15px"
                }}
                onChange={this.handleChangeSearch}
                onPressEnter={this.handleChangeSearch}
              ></input>
            </div>
          </div>

          {/* <div class="row" style={{ marginTop: "20px" }}> */}
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            </div>
          </div>

          <div align="center" id={this.state.loader_progress}></div>

          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
              style={{ paddingTop: "5px" }}
            >
              {this.state.tableSearchText === "" ? (
                <Table
                  {...this.state.tableState}
                  id="myTable"
                  bordered
                  dataSource={this.state.campList}
                  onChange={onChange}
                  columns={columns}
                  loading={this.state.loading}
                  className={`${tableCSS} "ant-table-thead"`}
                  scroll={{ x: 1280, y: 4000 }}
                  expandedRowRender={(record) => (
                    <div>
                      <div class="container-fluid">
                        <table
                          border="1"
                          style={{
                            tableLayout: "auto",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tr>
                            <th style={{ fontWeight: "400", width: "7.5%" }}>
                              &nbsp;Campaign Type :
                            </th>
                            <td style={{ width: "9.5%" }}>
                              <b>
                                &nbsp;
                                {record.ABM ? record.ABM : record.ABM}
                              </b>
                            </td>
                            <th style={{ fontWeight: "400", width: "7.5%" }}>
                              &nbsp;Start Date :
                            </th>
                            <td style={{ width: "9.5%" }}>
                              <b>
                                &nbsp;
                                {record.startDate
                                  ? record.startDate
                                  : record.advstartDate}
                              </b>
                            </td>
                            <th style={{ fontWeight: "400", width: "7.5%" }}>
                              &nbsp;End Date :
                            </th>
                            <td style={{ width: "9.5%" }}>
                              <b>
                                &nbsp;
                                {record.endDate
                                  ? record.endDate
                                  : record.advendDate}
                              </b>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  )}
                  pagination={{
                    pageSize: this.state.pageSize,
                    position: "bottom",
                  }}
                ></Table>
              ) : (
                <Table
                  {...this.state.tableState}
                  id="myTable"
                  bordered
                  dataSource={this.state.campListSearch}
                  onChange={onChange}
                  columns={columns}
                  loading={this.state.loading}
                  className={`${tableCSS} "ant-table-thead"`}
                  scroll={{ x: 1280, y: 4000 }}
                  expandedRowRender={(record) => (
                    <div>
                      <div class="container-fluid">
                        <table
                          border="1"
                          style={{
                            tableLayout: "auto",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tr>
                            <th style={{ fontWeight: "400", width: "7.5%" }}>
                              &nbsp;Campaign Type :
                            </th>
                            <td style={{ width: "9.5%" }}>
                              <b>
                                &nbsp;
                                {record.ABM ? record.ABM : record.ABM}
                              </b>
                            </td>
                            <th style={{ fontWeight: "400", width: "7.5%" }}>
                              &nbsp;Start Date :
                            </th>
                            <td style={{ width: "9.5%" }}>
                              <b>
                                &nbsp;
                                {record.startDate
                                  ? record.startDate
                                  : record.advstartDate}
                              </b>
                            </td>
                            <th style={{ fontWeight: "400", width: "7.5%" }}>
                              &nbsp;End Date :
                            </th>
                            <td style={{ width: "9.5%" }}>
                              <b>
                                &nbsp;
                                {record.endDate
                                  ? record.endDate
                                  : record.advendDate}
                              </b>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  )}
                  pagination={{
                    pageSize: this.state.pageSize,
                    position: "bottom",
                  }}
                ></Table>
              )}
            </div>
          </div>

          <div class="row">
            <div
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
              style={{ marginTop: "-45px", marginLeft: "5px" }}
            >
              &nbsp;Records per page : &nbsp;
              <select
                defaultValue={this.state.pageSize}
                onChange={this.handleChangePageSize}
                id="pacing1"
                class="input-small"
                className="form-control"
                name="pacing"
                style={{ width: "71px", height: "30px", display: "initial" }}
              >
                <option value="25" selected>
                  25
                </option>
                <option value="50">50</option>
                <option value="75">75</option>
              </select>
            </div>
            {/* Anshul-5857: added assign all button */}
            <div
              style={{ textAlign: "right", marginTop: "-45px",}}
            >
              <button
                className="btn add-button assign-all"
                onClick={this.handleAssignAllClick}
                disabled={!this.isAssignAllEnabled()}
                style={{ height: "34px" }}
              >
                Assign All
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
qualityDashboard.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(
  withRouter(qualityDashboard)
);
